import React from "react";
import ReactTooltip from "react-tooltip";
import styled from "@emotion/styled";

const Image = styled.img`
  opacity: 0.7;
  width: ${props => props.maxWidth};
  &:hover {
    opacity: 0.5;
  }
`;

const GiftCardTooltip = ({ index, type, img, dataOffset, imgWidth }) => (
  <>
    <ReactTooltip
      effect="solid"
      className="tooltip-brand-page-type"
      id={`cardType${index}`}
    />
    <Image
      className="tooltip-image"
      data-offset={dataOffset}
      data-for={`cardType${index}`}
      data-tip={
        type.toLowerCase().includes("ecode")
          ? "eGiftCards will be delivered via email instantly."
          : "Cards will be mailed within 2-3 business days."
      }
      src={img}
      maxWidth={imgWidth}
      alt="tooltip icon"
    />
  </>
);

export default GiftCardTooltip;
